import type { StepCard } from '../types/landing'

export const steps: StepCard[] = [
  {
    id: 'zone',
    index: '01',
    title: 'Choose a learning zone',
    copy: "Pick the challenge that fits the learner's grade and current level.",
  },
  {
    id: 'print',
    index: '02',
    title: 'Print and play',
    copy:
      'Use the ready-to-go activity at home, in class, or during independent practice.',
  },
  {
    id: 'track',
    index: '03',
    title: 'Check and track',
    copy:
      'Use answer keys and printable progress tools to celebrate each completed challenge and keep momentum going.',
  },
]
